import { ReportMessageSource } from '~context/report';

import ReportIcon from '../../../../../public/img/reports/Report_Icon.svg';
import { ReportComponentWrapper } from '../styles';

export const ReportPopup: React.FC<{
	className?: string;
	reportMessageAction: (source: ReportMessageSource) => void;
	visible: boolean;
}> = ({ className, reportMessageAction, visible }) => {
	return (
		<ReportComponentWrapper
			className={className}
			onClickCapture={() => {
				if (!visible) {
					reportMessageAction(ReportMessageSource.Button);
				}
			}}
		>
			<ReportIcon width={6} height={17} />
		</ReportComponentWrapper>
	);
};
